// The demo console's one piece of shared state: the simulated venue the API answers from (spec/24 §4.2).
//
// The API client is made once, before anything renders (`main.tsx`), and the venue only exists once the visitor is
// signed in and their window has started (`DemoFrame.tsx`). This object is how the second reaches the first: the
// frame sets `store` when the window starts and clears it when it ends; the backend (`backend.ts`) reads it on every
// request. A test hands in a runtime of its own through the context.

import { createContext, useContext } from 'react';

import { createDemoRuntime, type DemoRuntime } from './backend';

/** The browser build's runtime: one per page. */
export const demoRuntime: DemoRuntime = createDemoRuntime();

export const DemoRuntimeContext = createContext<DemoRuntime>(demoRuntime);

export function useDemoRuntime(): DemoRuntime {
  return useContext(DemoRuntimeContext);
}
